"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkI7EIKUJScjs = require('./chunk-I7EIKUJS.cjs');


var _chunkXQPAMLNGcjs = require('./chunk-XQPAMLNG.cjs');


var _chunkOPOA3RRVcjs = require('./chunk-OPOA3RRV.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/index.ts
var DEX4 = {
  [_chunkNE5AG7IWcjs.DEX_VERSION.v1]: _chunkOPOA3RRVcjs.DEX,
  [_chunkNE5AG7IWcjs.DEX_VERSION.v2_1]: _chunkI7EIKUJScjs.DEX,
  [_chunkNE5AG7IWcjs.DEX_VERSION.v2_2]: _chunkXQPAMLNGcjs.DEX
};



exports.DEX = DEX4;
//# sourceMappingURL=chunk-AY2ITIKA.cjs.map